export default __webpack_public_path__ + "static/media/slide5.bd9e310e.jpg";